<template>
	<div>
		<div class="sense-main">
			<div class="sense-table-list sense-table-warn">
				<el-form label-width="100px">
					<el-form-item label="余额提醒 :">
						<el-switch class="balance-switch" v-model="open" disabled @click.native="setBalance"></el-switch>
						<el-tooltip class="item" effect="dark" placement="bottom" v-show="!showAmount">
							<div class="sense-slot" slot="content">
				    			注意：当账户可用余额小于该预警值时，每当发生一次消费行为<br>
				    			(例如：购买套餐、最终用户绑定许可)便会短信提醒一次。
				    		</div>
							<span class="ssicon ss-question"></span>
						</el-tooltip>
						<span class="warn-text" v-show="showAmount">
							( 预警额度：￥{{ warnAmount }} <a href="javascript:;" @click="editWarnAmount">修改</a> )							
						</span>
					</el-form-item>
				</el-form>
			</div>		
		</div>
		<div class="all-dialog">
			<el-dialog class="sense-dialog" title="预警设置" :visible.sync="balanceVisible" width="422px">
				<el-form :model="balanceForm" :rules="balanceRule" ref="balanceForm" size="small" label-width="80px">
					<el-form-item class="warn-form-item" prop="warnAmount" label="预警额度 :">						
						<el-input v-model="balanceForm.warnAmount" auto-complete="off" maxlength="6"></el-input>
						<span class="warn-unit">元</span>						
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="balanceVisible = false">取 消</el-button>
					<el-button type="primary" size="small" @click="balanceFormSubmit">确 定</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import { ajax } from '../api/api.js'

	export default {
		data() {
			//自定义预警额度校验规则
			let warnAmountRule = (rule, value, callback) => {
				if (!value) {
					callback(new Error('请输入预警额度'));
				} else {
					let reg = /^[0-9]+$/;
					if (reg.test(value) && value != 0) {
						callback();
					} else {
						callback(new Error('预警额度只能输入正整数'));
					};
				};
			};
			return {
				open: false,
				showAmount: false,
				balanceVisible: false,
				warnAmount: '',
				balanceForm: {
					warnAmount: ''
				},
				balanceRule: {
		            warnAmount: [
		            	{validator: warnAmountRule, trigger: 'change'}	        
		            ]
		        }	
			}
		},
		methods: {
			loadBalanceData() {	
				let url = '/notice/balance/view.do';
				let param = {};

				ajax(url, param).then(response => {
					if (response.code == 0) {
						this.open = response.data.open;
						if (response.data.open == true) {
							this.showAmount = true;
							this.warnAmount = response.data.warnAmount;
						} else {
							this.showAmount = false;
						};
					} else {
						this.$message({
							message: response.desc,
							type: 'warning'
						});
					};				
				});					
			},
			setBalance() {
				if (this.open == false) {
					this.balanceVisible = true;
					this.balanceForm.warnAmount = '';
				} else {
					this.$confirm('关闭后，系统将不再发送短信和站内信提醒，确定要关闭吗？', '提示', {
						type: 'warning'
					}).then(() => {
						let url = '/notice/balance/set.do';
						let param = {
							open: false
						};

						ajax(url, param).then(response => {
							if (response.code == 0) {
								this.balanceVisible = false;
								this.$message({
									message: '关闭成功',
									type: 'success'
								});
								this.loadBalanceData();
							} else {
								this.$message({
									message: response.desc,
									type: 'warning'
								});
							};				
						});							
					}).catch(() => {

					});
				};
			},
			balanceFormSubmit() {
				this.$refs.balanceForm.validate((valid) => {
		            if (valid) {
						let url = '/notice/balance/set.do';
						let param = {
							open: true,
							warnAmount: this.balanceForm.warnAmount
						};

						ajax(url, param).then(response => {
							if (response.code == 0) {
								this.balanceVisible = false;
								this.$refs.balanceForm.resetFields();
								this.$message({
									message: '预警额度设置成功',
									type: 'success'
								});
								this.loadBalanceData();
							} else {
								this.$message({
									message: response.desc,
									type: 'warning'
								});
							};				
						});
					} else {			          
			            return false;
		            }
		        });
			},
			editWarnAmount() {
				this.balanceVisible = true;
				this.balanceForm.warnAmount = '';
			},
		},
		mounted() {
			this.loadBalanceData();
		},
	}
</script>

<style scoped lang="scss">	

</style>


// WEBPACK FOOTER //
// BalanceWarn.vue?ffdbc5c4